import type { PmNodeConverter, PmNodeJson } from './../../pm-converters/types';
import type { BulletedListData } from './../../ricos-schema/legacy/wix/rich_content/v1';
import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { BulletedListNode, ListItemNode } from './../../ricos-types';

const bulletedListDataDefaults = { indentation: 0, offset: 0 } as const;
export const bulletedListConverter: PmNodeConverter = {
  toPm: {
    types: [Node_Type.BULLETED_LIST],
    // @ts-expect-error $TSFixMe
    convert: (node: BulletedListNode, visit: (node: BulletedListNode) => PmNodeJson[]) => {
      const dataWithDefaults = (
        Object.entries(bulletedListDataDefaults) as [keyof BulletedListData, number][]
      ).reduce((acc, [key, defaultValue]) => {
        acc[key] = node.bulletedListData?.[key] ?? defaultValue;
        return acc;
      }, {} as BulletedListData);
      return {
        type: Node_Type.BULLETED_LIST,
        attrs: {
          ...dataWithDefaults,
          id: node.id,
        },
        content: visit(node),
      };
    },
  },
  fromPm: {
    types: [Node_Type.BULLETED_LIST],
    // @ts-expect-error $TSFixMe
    convert: (node: PmNodeJson, visit: (node: PmNodeJson) => ListItemNode[]) => {
      const { attrs = {} } = node;
      const { id, ...data } = attrs;
      return {
        type: Node_Type.BULLETED_LIST,
        id,
        nodes: visit(node),
        bulletedListData: (Object.keys(data) as (keyof BulletedListData)[]).reduce((acc, key) => {
          if (data[key] !== bulletedListDataDefaults[key]) {
            acc[key] = data[key];
          }
          return acc;
        }, {} as BulletedListData),
      };
    },
  },
};
